'use strict'

import Helper from '@/utils/helper'
import FileInfo from '@/app/service/api/model/common/file-info'

class AdAudioItem {
  constructor ({ id, file, volumeLevel }) {
    if (Helper.isDefined(volumeLevel)) {
      Helper.checkInt('AdTextItem.volumeLevel', volumeLevel)
    }

    this.id = id
    this.file = new FileInfo(file)
    this.volumeLevel = Helper.isDefined(volumeLevel) ? (volumeLevel / 100) : null
  }

  getId () {
    return this.id
  }

  getFile () {
    return this.file
  }

  getVolume () {
    return this.volumeLevel
  }

  toString () {
    return 'AdAudioItem{' +
      ', id=' + '\'' + this.id + '\'' +
      ', file=' + '\'' + this.file + '\'' +
      ', volumeLevel=' + '\'' + this.volumeLevel + '\'' +
      '}'
  }
}

export default AdAudioItem
